<div class="skill-list">
    <mat-form-field appearance="outline">
      <mat-label>Skills</mat-label>
      <mat-chip-grid #chipGrid aria-label="Skill selection">
        @for (skill of selectedSkills(); track $index) {
          <mat-chip-row (removed)="remove(skill)">
            {{skill}}
            <button matChipRemove [attr.aria-label]="'remove ' + skill">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        name="currentSkill"
        placeholder="New Skill..."
        #skillInput
        [(ngModel)]="currentSkill"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        @for (skill of filteredSkills(); track skill) {
          <mat-option [value]="skill">{{skill}}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
